<bci-wk-modal class="modal">
  <div class="container-modal">
    <img class="war" src="./assets/images/no-visits.png" alt="waricon" />
    <div class="title wk-padding-top-24">
      <bci-wk-modal-title bciWkTypeH600
        >Aún no tienes visitas agendadas</bci-wk-modal-title
      >
    </div>
    <div class="subtitle">
      <p>Te invitamos a agendar tu próxima visita.</p>
    </div>
    <bci-wk-modal-actions>
      <button bciWkButtonTertiary (click)="close()">Entendido</button>
      <button bciWkButtonPrimary (click)="backToSchedule()">
        Ir a agendar visita
      </button>
    </bci-wk-modal-actions>
  </div>
</bci-wk-modal>
